/**
 * @module util/time
 * @description Timezone-aware time utilities for Palestine (Asia/Gaza).
 * Provides helpers for normalizing and formatting time values
 * used across the admin dashboard.
 */

import dayjs from "./dayjs";

/** @constant {string} IANA timezone identifier for Palestine */
export const TIMEZONE = "Asia/Gaza";

/**
 * Converts a time string ("HH:mm:ss" or "HH:mm") to "HH:mm" format.
 * Used when loading schedule data from the API so that `<input type="time">`
 * and outgoing requests always use a consistent "HH:mm" format.
 *
 * @param {string|null|undefined} time - Time string from the API (e.g. "09:00:00")
 * @returns {string} Time in "HH:mm" format, or "" if input is falsy
 *
 * @example
 * toHHmm("09:00:00"); // "09:00"
 * toHHmm("14:30");    // "14:30"
 * toHHmm(null);        // ""
 */
export function toHHmm(time) {
    if (!time) return "";
    return dayjs(`2000-01-01 ${time}`).format("HH:mm");
}
